import { createContext } from 'react';
import { AllIssueContextType } from '../types';

export const AllIssuesContext = createContext({} as AllIssueContextType);
